import { Plug } from 'lucide-react';
import { useTranslation } from 'react-i18next';

export function IntegrationsEmptyState() {
  const { t } = useTranslation('integrationsModule');

  return (
    <div
      className="rounded-lg border border-dashed border-border bg-muted/20 px-6 py-8 sm:px-8"
      data-testid="integrations-empty-state"
    >
      <div className="mx-auto flex max-w-sm flex-col items-center text-center">
        <div className="flex h-10 w-10 items-center justify-center rounded-full border border-border bg-background">
          <Plug className="h-5 w-5 text-muted-foreground" aria-hidden />
        </div>

        <h3 className="mt-3 text-base font-semibold text-foreground">{t('empty.title')}</h3>
        <p className="mt-1.5 text-sm leading-relaxed text-muted-foreground">{t('empty.description')}</p>
      </div>
    </div>
  );
}
